import { Component, OnInit, HostListener } from '@angular/core';
import { HeaderNav } from '@flysas/headernav-lib';
import { AppService } from '../../app.service';
declare let $: any;

@Component({
  selector: 'app-navtabs',
  templateUrl: './navtabs.component.html'
})
export class NavtabsComponent implements OnInit {
  public marketSelector;
  public burgerMenu;
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    if (targetElement.id === 'burger-menu') {
      this.burgerMenu.toggle();
      $('#nav-onboard').removeClass('hide');
    } else if (targetElement.id === 'market-selector' || targetElement.parentElement.id === 'market-selector') {
      this.marketSelector.toggle();
    }
  }

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.initiateHeaderNavTabs();
  }

  private initiateHeaderNavTabs() {
    this.appService.setOrigin();
    const marketSelectorObject = {
      type: 'marketSelector',
      lang: this.appService.getLanguage(),
      market: this.appService.getPOS()
    };
    const burgerSelectorObject = {
      type: 'burger',
      lang: this.appService.getLanguage(),
      market: this.appService.getPOS()
    };
    if (AppService.appOrigin !== '' && AppService.appOrigin !== undefined && AppService.appOrigin !== null) {
      marketSelectorObject['airport'] = AppService.appOrigin;
      burgerSelectorObject['airport'] = AppService.appOrigin;
    }
    this.marketSelector = new HeaderNav('#HeaderNavigation', marketSelectorObject);
    this.burgerMenu = new HeaderNav('#HeaderNavigation', burgerSelectorObject);
  }

}
